import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const KpiCard = ({ statusDef, value, total, onClick, selected, icon, detail, externalStyle, NP }) => {
  const count = value ? value.count : 0;
  const percent = total === 0 ? 0 : (count / total) * 100;
  const { color } = statusDef;

  const handleDivOnCLick = () => {
    if (NP) {
      const status = statusDef.id || null;
      onClick(status);
    } else {
      const status = selected ? null : statusDef.id || null;
      onClick(status);
    }
  };
  return (
    <div
      className={`card ecommerce-widget ${selected ? "" : "shadow border"}`}
      style={{
        cursor: "pointer",
        width: "100%",
      }}
      onClick={handleDivOnCLick}
      onKeyPress={handleDivOnCLick}
      role="button"
      styling="link"
      tabIndex="0"
    >
      <div className="card-body support-ticket-font" style={{ fontFamily: externalStyle && externalStyle.fontFamily }}>
        <div className="row" style={NP ? { display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0px 15px" } : null}>
          <div className={NP ? "" : "col-7"}>
            <span style={{ ...externalStyle }}>{statusDef.text}</span>
            <div className="d-flex align-items-end">
              <h3 className="total-num counter">{count}</h3>
              <div className="pl-1" style={NP ? { marginBottom: "0.2rem" } : null}>
                de {total}
              </div>
            </div>
          </div>
          <div className={NP ? "" : "col-5 d-flex justify-content-end"}>
            {icon && !detail ? (
              <FontAwesomeIcon className={color ? "" : "text-secondary"} color={color || ""} size="3x" icon={icon} style={{ filter: "drop-shadow(0px 0px)" }} />
            ) : (
              <></>
            )}
            {detail || <></>}
          </div>
        </div>
        <div className="progress-showcase" style={NP ? { marginTop: "5px" } : null}>
          {NP ? <div style={{ fontWeight: "bold", fontSize: "16px", textAlign: "right", marginTop: "0" }}> {Math.round(percent)}%</div> : ""}
          <div className="progress sm-progress-bar">
            {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
            <div
              className="progress-bar"
              role="progressbar"
              style={{ width: `${percent}%`, backgroundColor: `${color}` }}
              aria-valuenow={percent}
              aria-valuemin="0"
              aria-valuemax="100"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default KpiCard;
